export default class InitializeOnce {

  async initialize(...parameters) {

    if (this.initializePromise !== null) {
      return this.initializePromise;
    }

    this.initializePromise = this.doInitialize(...parameters);

    return this.initializePromise;

  }

}